import Cookie from "universal-cookie";
import { GET_AZURE_SPEECH_TOKEN } from "../../src/endpoint";
import apiCall from "./apiCall";
export async function getTokenOrRefresh() {
  const cookie = new Cookie();
  const speechToken = cookie.get("speech-token");

  if (speechToken === undefined) {
    try {
      const res = await apiCall("GET", GET_AZURE_SPEECH_TOKEN);
      const token = res.token;
      const region = res.region;
      cookie.set("speech-token", region + ":" + token, {
        maxAge: 540,
        path: "/",
      });

      return { authToken: token, region: region };
    } catch (err) {
      // console.log(err.response);
      return { authToken: null, error: err.response };
    }
  } else {
    const idx = speechToken.indexOf(":");
    return {
      authToken: speechToken.slice(idx + 1),
      region: speechToken.slice(0, idx),
    };
  }
}
